<div class="container personas">
  <h1 class="titulo-terminos" *ngIf="!param && languaje === 'en'">Terms and Conditions</h1>
  <h1 class="titulo-terminos" *ngIf="!param && languaje === 'es'">Términos y Condiciones</h1>
  <div class="contenedor-pestanas" [style.margin]="param ? '0' : '20px 0'">
    <div class="row tab-v3">
      <div class="col-12 col-lg-3 pestanas">
        <ul class="nav nav-pills nav-stacked">
          <app-miles-care-protection (x)="resetFlags(); tabs_state.care_protection = true" [is_active]="tabs_state.care_protection" style="width: 100%">
          </app-miles-care-protection> 
          <app-general-conditions-life (x)="resetFlags(); tabs_state.upper_general = true"
            [is_active]="tabs_state.upper_general" style="width: 100%"></app-general-conditions-life>
          <app-glosary (x)="resetFlags(); tabs_state.glosary = true"
            [is_active]="tabs_state.glosary" style="width: 100%"></app-glosary> 
          <app-business-model (x)="resetFlags(); tabs_state.business_model = true" [is_active]="tabs_state.business_model"
            style="width: 100%"></app-business-model>
          <app-coverage-provisions (x)="resetFlags(); tabs_state.coverage_provisions = true"
            [is_active]="tabs_state.coverage_provisions" style="width: 100%"></app-coverage-provisions>
          <app-stay-care-life (x)="resetFlags(); tabs_state.stay_care = true" [is_active]="tabs_state.stay_care"
            style="width: 100%"></app-stay-care-life>
          <app-fly-care-life (x)="resetFlags(); tabs_state.fly_care = true" [is_active]="tabs_state.fly_care"
            style="width: 100%"></app-fly-care-life> 
          <app-additional-protection (x)="resetFlags(); tabs_state.additional_protection = true" [is_active]="tabs_state.additional_protection"
            style="width: 100%"></app-additional-protection>
            <app-exclusions-lm (x)="resetFlags(); tabs_state.exclusions_lm = true" [is_active]="tabs_state.exclusions_lm" style="width: 100%">
            </app-exclusions-lm>
          
          <app-miscellaneous-coverage (x)="resetFlags(); tabs_state.coverage = true" [is_active]="tabs_state.coverage"
            style="width: 100%"></app-miscellaneous-coverage>
          <app-general-information (x)="resetFlags(); tabs_state.information = true" [is_active]="tabs_state.information"
            style="width: 100%"></app-general-information>
          <app-privacy (x)="resetFlags(); tabs_state.privacy = true" [is_active]="tabs_state.privacy"
            style="width: 100%"></app-privacy>
        </ul>
      </div>
      <div class="col-12 col-lg-9 contenido">
        <div class="tab-content">
          <app-miles-care-protection [show_content]="tabs_state.care_protection"></app-miles-care-protection>
          <app-general-conditions-life [show_content]="tabs_state.upper_general"></app-general-conditions-life>
          <app-glosary [show_content]="tabs_state.glosary"></app-glosary>
          <app-business-model [show_content]="tabs_state.business_model"></app-business-model>
          <app-coverage-provisions [show_content]="tabs_state.coverage_provisions"></app-coverage-provisions>
          <app-stay-care-life [show_content]="tabs_state.stay_care"></app-stay-care-life>
          <app-fly-care-life [show_content]="tabs_state.fly_care"></app-fly-care-life>
          <app-additional-protection [show_content]="tabs_state.additional_protection"></app-additional-protection>
          <app-exclusions-lm [show_content]="tabs_state.exclusions_lm"></app-exclusions-lm>
          
          <app-miscellaneous-coverage [show_content]="tabs_state.coverage"></app-miscellaneous-coverage>
          <app-general-information [show_content]="tabs_state.information"></app-general-information>
          <app-privacy [show_content]="tabs_state.privacy"></app-privacy>
        </div>
      </div>
    </div>
  </div>
</div>
